var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",class:{
    expanded: _vm.expanded,
    'expandable-content custom-scrollbar': !_vm.isQuickSearch
  }},[_vm._t("default"),_vm._v(" "),(!_vm.expanded)?_c('div',{staticClass:"expand-container"},[_c('CButton',{staticClass:"expand-button",attrs:{"size":"sm"},on:{"click":_vm.expand}},[_vm._v("\n      "+_vm._s(_vm.$t('more'))+"\n    ")])],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }